import React from "react";
import { withRouter } from "react-router-dom";
import { AppMediaQuery, Link } from "ui-components";

import logoUrl from "@public/assets/images/PSHSA_Logo.svg";

import {
  HeaderWrapper,
  HeaderContent,
  HeaderLogo,
  HeaderMenu,
  HeaderMenuItem
} from "./styled";

const Header = ({ history }) => {
  const renderMenuItems = () => {
    if (history.location.pathname !== "/") {
      return (
        <HeaderMenuItem>
          <Link to="/">
            Restart
          </Link>
        </HeaderMenuItem>
      );
    }
  };

  return (
    <HeaderWrapper>
      <AppMediaQuery>
        <HeaderContent>
          <HeaderLogo src={logoUrl} alt="logo" />
          <HeaderMenu>
            {renderMenuItems()}
          </HeaderMenu>
        </HeaderContent>
      </AppMediaQuery>
    </HeaderWrapper>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/common/components/AppHeader/index.jsx